import { memo, useEffect, useCallback, useState } from "react";
import Form from "../Form.js";
import { useSnackbar } from "../../utils/index.js"
import Spinner from "../Spinner.js"
import {
    getInspectors,
    getOrganizations,
    getOrganization,
    getUsersData,
    getUserRole,
    updateOwner,
    deleteOwner,
    createOwner,
    addExternalSaleAnimalsToOwner,
    getExternalSaleAnimalsForOwner,
} from "../../api/index.js";
import {
    IconButton,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AreYouSurePopup from "../popups/AreYouSurePopup.js";
import { dayjs } from "../../utils/index.js";



const OwnerForm = ({
    datePickerWidth = "595px",
    isCreate, // Declares if the form is used for creation (true) or update (false)
    fetchedOwner = {}, // Used in update ~ the owner to be updated object
    setFetchedOwner = {}, // Used in update ~ the set method of the owner to be updated 
    ownerId = {}, // Used in update ~ the id of the onwer to be updated
    setIsOwnerSelected, // Used in update ~ declares if owner is selected to be updated
    isFromList, // Declares if the form is rendered in list page or not 
    setIsCreateOpen, // Used when isFromList is true ~ to set the open status of the modal
    fetchListData = () => { console.log("Ok") }// Used when isFromList is true ~ to update the table
}
) => {
    const [fetchedInspectors, setFetchedInspectors] = useState([]);
    const [inspectorDropdownValues, setInspectorDropdownValues] = useState([]);

    const [fetchedOrganizations, setFetchedOrganizations] = useState([]);
    const [organizationDropdownValues, setOrganizationDropdownValues] = useState([]);
    const [fetchedOrganization, setFetchedOrganization] = useState(null);

    const [fetchedUsers, setFetchedUsers] = useState([]);
    const [userDropdownValues, setUserDropdownValues] = useState([]);

    const [userRole, setUserRole] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [createdOwnerId, setCreatedOwnerId] = useState(null);
    const [externalSaleAnimals, setExternalSaleAnimals] = useState([]);
    const [selectedAnimalIds, setSelectedAnimalIds] = useState([]);
    const [declarationAccepted, setDeclarationAccepted] = useState(false);
    const [isExternalSalesDialogOpen, setIsExternalSalesDialogOpen] = useState(false);

    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            try {
                const { inspectors } = await getInspectors();
                setFetchedInspectors(inspectors);
                const inspDropdownArr = []
                for (var inspector of inspectors) {
                    inspDropdownArr.push({ value: `${inspector.lastName} ${inspector.firstName}`, text: `${inspector.lastName} ${inspector.firstName}` });
                }
                setInspectorDropdownValues(inspDropdownArr);

                const { organization } = await getOrganization();
                setFetchedOrganization(organization);

                const { organizations } = await getOrganizations();
                setFetchedOrganizations(organizations);
                const orgDropdownArr = [];
                for (var org of organizations) {
                    orgDropdownArr.push({ value: org.name, text: org.name });
                }
                setOrganizationDropdownValues(orgDropdownArr);

                const { users } = await getUsersData();
                setFetchedUsers(users);
                const usersDropdownArr = [];
                for (var user of users) {
                    usersDropdownArr.push({ value: user.username, text: user.username });
                }
                setUserDropdownValues(usersDropdownArr);

                const { role } = await getUserRole();
                setUserRole(role);
            } catch (err) {
                error(err)
            }
        }
    )
    useEffect(() => {
        fetchData();
    }, []);

    const createFormContent = [
        {
            customType: "input",
            id: "code",
            type: "text",
            placeholder: "Κωδικός στην εκτροφή",
            required: true,
        },
        {
            customType: "dropdown",
            id: "inspector",
            items: inspectorDropdownValues,
            placeholder: "Ελεγκτής",
            required: true,
        },
        {
            customType: "input",
            id: "lastName",
            type: "text",
            placeholder: "Επώνυμο",
            required: true,
        },
        {
            customType: "input",
            id: "firstName",
            type: "text",
            placeholder: "Όνομα",
            required: true,
        },
        {
            customType: "input",
            id: "fatherName",
            type: "text",
            placeholder: "Όνομα Πατρός",
        },
        {
            customType: "input",
            id: "afm",
            type: "text",
            placeholder: "Α.Φ.Μ",
        },
        {
            customType: "input",
            id: "address",
            type: "text",
            placeholder: "Διεύθυνση",
        },
        {
            customType: "input",
            id: "city",
            type: "text",
            placeholder: "Πόλη",
            required: true
        },
        {
            customType: "input",
            id: "county",
            type: "text",
            placeholder: "Νομός",
        },
        {
            customType: "input",
            id: "postalCode",
            type: "text",
            placeholder: "Τ.Κ",
        },
        {
            customType: "input",
            id: "phoneNumber",
            type: "text",
            placeholder: "Σταθερό",
        },
        {
            customType: "input",
            id: "cellPhone",
            type: "text",
            placeholder: "Κινητό",
        },
        {
            customType: "input",
            id: "email",
            type: "text",
            placeholder: "Διεύθυνση e-mail",
        },
        {
            customType: "date-picker",
            id: "outDate",
            type: "desktop",
            label: "Ημ/νια εξόδου",
            width: datePickerWidth,
            background: "third"
        },
        {
            customType: "dropdown",
            id: "organization",
            items: organizationDropdownValues,
            defaultValue: fetchedOrganization?.name,
            placeholder: "Οργάνωση",
            disabled: true,
        },
        {
            customType: "dropdown",
            id: "user",
            items: userDropdownValues,
            placeholder: "Χρήστης"
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const selectOwnerFormContent = [
        {
            customType: "input",
            id: "code",
            type: "text",
            placeholder: "Κωδικός στην εκτροφή",
            value: fetchedOwner?.code,
            required: true,
            disabled: true,
        },
        {
            customType: "dropdown",
            id: "inspector",
            items: inspectorDropdownValues,
            placeholder: "Ελεγκτής",
            defaultValue: fetchedOwner?.inspector,
            required: true,
        },
        {
            customType: "input",
            id: "lastName",
            type: "text",
            placeholder: "Επώνυμο",
            value: fetchedOwner?.lastName,
            required: true,
        },
        {
            customType: "input",
            id: "firstName",
            type: "text",
            placeholder: "Όνομα",
            value: fetchedOwner?.firstName,
            required: true,
        },
        {
            customType: "input",
            id: "fatherName",
            type: "text",
            placeholder: "Όνομα Πατρός",
            value: fetchedOwner?.fatherName,
        },
        {
            customType: "input",
            id: "afm",
            type: "text",
            placeholder: "Α.Φ.Μ",
            value: fetchedOwner?.afm,
        },
        {
            customType: "input",
            id: "address",
            type: "text",
            placeholder: "Διεύθυνση",
            value: fetchedOwner?.address,
        },
        {
            customType: "input",
            id: "city",
            type: "text",
            placeholder: "Πόλη",
            value: fetchedOwner?.city,
            required: true,
        },
        {
            customType: "input",
            id: "county",
            type: "text",
            placeholder: "Νομός",
            value: fetchedOwner?.county,
        },
        {
            customType: "input",
            id: "postalCode",
            type: "text",
            placeholder: "Τ.Κ",
            value: fetchedOwner?.postalCode,
        },
        {
            customType: "input",
            id: "phoneNumber",
            type: "text",
            placeholder: "Σταθερό",
            value: fetchedOwner?.phoneNumber,
        },
        {
            customType: "input",
            id: "cellPhone",
            type: "text",
            placeholder: "Κινητό",
            value: fetchedOwner?.cellPhone,
        },
        {
            customType: "input",
            id: "email",
            type: "text",
            placeholder: "Διεύθυνση e-mail",
            value: fetchedOwner?.email,
        },
        {
            customType: "date-picker",
            id: "createdAt",
            type: "desktop",
            label: "Ημ/νια Εισαγωγής",
            width: datePickerWidth,
            background: "third",
            value: dayjs(fetchedOwner?.createdAt) || null,
            disabled: true
        },
        {
            customType: "date-picker",
            id: "outDate",
            type: "desktop",
            label: "Ημ/νια εξόδου",
            width: datePickerWidth,
            background: "third",
            value: dayjs(fetchedOwner?.outDate) || null,
        },
        {
            customType: "dropdown",
            id: "organization",
            items: organizationDropdownValues,
            placeholder: "Οργάνωση",
            defaultValue: fetchedOwner?.organization,
            disabled: true
        },
        {
            customType: "dropdown",
            id: "user",
            items: userDropdownValues,
            placeholder: "Χρήστης",
            defaultValue: fetchedOwner?.user,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Αποθήκευση",
        },
    ]


    const finishOwnerCreation = (message) => {
        success(message);
        if (isFromList) {
            setIsCreateOpen(false);
            fetchListData();
        } else {
            window.location.assign('/owners/preview');
        }
    };

    const closeExternalSalesDialog = () => {
        setIsExternalSalesDialogOpen(false);
        setCreatedOwnerId(null);
        setExternalSaleAnimals([]);
        setSelectedAnimalIds([]);
        setDeclarationAccepted(false);
        if (isCreate) finishOwnerCreation("Η εκτροφή δημιουργήθηκε επιτυχώς");
    };

    const toggleExternalSaleAnimal = (animalId) => {
        setSelectedAnimalIds((currentIds) => (
            currentIds.includes(animalId)
                ? currentIds.filter((id) => id !== animalId)
                : [...currentIds, animalId]
        ));
    };

    const handleExternalSaleAnimalsSubmit = async () => {
        if (selectedAnimalIds.length === 0) {
            error("Επιλέξτε τουλάχιστον ένα ζώο");
            return;
        }
        if (!declarationAccepted) {
            error("Πρέπει να επιβεβαιώσετε ότι τα επιλεγμένα ζώα υπάρχουν στην εκτροφή");
            return;
        }

        setIsLoading(true);
        try {
            const { success: successCode, message } = await addExternalSaleAnimalsToOwner(
                createdOwnerId,
                selectedAnimalIds,
                declarationAccepted,
            );
            if (successCode) {
                setIsExternalSalesDialogOpen(false);
                if (isCreate) {
                    finishOwnerCreation(message);
                } else {
                    success(message);
                    setCreatedOwnerId(null);
                    setExternalSaleAnimals([]);
                    setSelectedAnimalIds([]);
                    setDeclarationAccepted(false);
                }
            } else {
                error(message);
            }
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    };

    const checkExternalSaleAnimals = async () => {
        setIsLoading(true);
        try {
            const { success: successCode, externalSaleAnimals: foundExternalSaleAnimals = [], message } = await getExternalSaleAnimalsForOwner(ownerId);
            if (!successCode) {
                error(message);
            } else if (foundExternalSaleAnimals.length === 0) {
                success("Δεν βρέθηκαν διαθέσιμα ζώα από εξωτερικές πωλήσεις");
            } else {
                setCreatedOwnerId(ownerId);
                setExternalSaleAnimals(foundExternalSaleAnimals);
                setIsExternalSalesDialogOpen(true);
            }
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    };

    const handleFormSubmit = async (values) => {
        setIsLoading(true)
        if (values.inspector) {
            values.inspector = fetchedInspectors.filter((insp) => `${insp.lastName} ${insp.firstName}` === values.inspector)[0]._id;
        }
        if (values.organization) {
            values.organization = fetchedOrganizations.filter((org) => org.name === values.organization)[0]._id;
        }
        if (values.outDate) {
            values.outDate = new Date(values.outDate);
        }
        if (values.user) {
            values.user = fetchedUsers.filter((user) => user.username === values.user)[0]._id;
        }

        const {
            success: successCode,
            message,
            ownerId,
            externalSaleAnimals: foundExternalSaleAnimals = [],
        } = await createOwner(values);
        if (successCode) {
            if (foundExternalSaleAnimals.length > 0) {
                setCreatedOwnerId(ownerId);
                setExternalSaleAnimals(foundExternalSaleAnimals);
                setIsExternalSalesDialogOpen(true);
            } else {
                finishOwnerCreation(message);
            }
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const handleOwnerUpdateSubmit = async (values) => {
        setIsLoading(true);
        var valuesToSend = { ...values };
        if (valuesToSend.inspector) {
            valuesToSend.inspector = fetchedInspectors.find((insp) => `${insp.lastName} ${insp.firstName}` === valuesToSend.inspector)._id;
        }
        if (valuesToSend.organization) {
            valuesToSend.organization = fetchedOrganizations.find((org) => org.name === valuesToSend.organization)._id;
        }
        if (valuesToSend.outDate) {
            valuesToSend.outDate = new Date(valuesToSend.outDate);
        }
        if (valuesToSend.user) {
            valuesToSend.user = fetchedUsers.find((user) => user.username === valuesToSend.user)._id;
        }

        const { success: successCode, message } = await updateOwner(ownerId, valuesToSend);
        if (successCode) {
            if (isFromList) {
                setIsCreateOpen(false);
                fetchListData();
            }
            success(message);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const handleDeleteOwner = async () => {
        setIsLoading(true);
        setIsPopupOpen(false);
        const { success: successCode, message } = await deleteOwner(ownerId);
        if (successCode) {
            success(message);
            if (isFromList) {
                setIsCreateOpen(false);
                fetchListData();
            } else {
                setIsOwnerSelected(false);
            }

        } else {
            error(message);
        }
        setFetchedOwner(null);
        setIsLoading(false);
    }

    return (
        <>
            <AreYouSurePopup
                width={"900px"}
                isOpen={isPopupOpen}
                title="Διαγραφή εκτροφής"
                titleColor="black"
                onClose={() => setIsPopupOpen(false)}
                innerText={`Είστε σίγουροι ότι θέλετε να διαγράψετε την εκτροφή "${fetchedOwner?.code} - ${fetchedOwner?.lastName} ${fetchedOwner?.firstName}";`}
                declineText="Πίσω"
                onDecline={() => setIsPopupOpen(false)}
                acceptText="Ναι, Διαγραφή εκτροφής"
                onAccept={() => handleDeleteOwner()}
            />
            <Spinner open={isLoading} />
            <Dialog
                open={isExternalSalesDialogOpen}
                onClose={closeExternalSalesDialog}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Ζώα από εξωτερικές πωλήσεις</DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 2 }}>
                        Βρέθηκαν ζώα από εκτελεσμένες πωλήσεις προς τον ίδιο αγοραστή.
                        Επιλέξτε μόνο όσα υπάρχουν σήμερα στην εκτροφή.
                    </Typography>
                    {externalSaleAnimals.map((animal) => (
                        <FormControlLabel
                            key={animal.animalId}
                            control={
                                <Checkbox
                                    checked={selectedAnimalIds.includes(animal.animalId)}
                                    onChange={() => toggleExternalSaleAnimal(animal.animalId)}
                                />
                            }
                            label={`${animal.registrationCode} (Παραγγελία #${animal.orderNumber})`}
                            sx={{ display: "flex", mb: 0.5 }}
                        />
                    ))}
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={declarationAccepted}
                                onChange={(event) => setDeclarationAccepted(event.target.checked)}
                                required
                            />
                        }
                        label="Δηλώνω υπεύθυνα ότι τα επιλεγμένα ζώα υπάρχουν στην εκτροφή."
                        sx={{ alignItems: "flex-start", mt: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeExternalSalesDialog}>Συνέχεια χωρίς προσθήκη</Button>
                    <Button
                        variant="contained"
                        onClick={handleExternalSaleAnimalsSubmit}
                        disabled={selectedAnimalIds.length === 0 || !declarationAccepted}
                    >
                        Προσθήκη επιλεγμένων ζώων
                    </Button>
                </DialogActions>
            </Dialog>
            <Form content={isCreate ? createFormContent : selectOwnerFormContent} onSubmit={isCreate ? handleFormSubmit : handleOwnerUpdateSubmit} toResetForm={false} />
            {!isCreate && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                    <Button variant="outlined" onClick={checkExternalSaleAnimals}>
                        Έλεγχος ζώων από εξωτερικές πωλήσεις
                    </Button>
                </Box>
            )}
            {userRole === "ADMIN" && !isCreate ? (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <IconButton
                        aria-label="delete"
                        onClick={() => setIsPopupOpen(true)}
                    >
                        <DeleteIcon />
                    </IconButton >
                </Box>
            ) : (
                <></>
            )}
        </>
    )
}

export default memo(OwnerForm)
